export const DEFAULT_PROPERTY_ACTIVE = false;
export const PROPERTY_ACTIVE_FIELD = 'propertyActive';
